/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'i18n!./ServiceabilityResources',
	'polyglot'
], function (serviceabilityResources, Polyglot) {

	const poly = new Polyglot({
		phrases: serviceabilityResources,
		allowMissing: true
	});

	class StringResources {
		/**
		 * Get the string resource for the given key and interpolation options
		 *
		 * @param {string} key The key of the string to return
		 * @param {object} [interpolationOptions] see poly.t documentation for details
		 * @returns {string} The corresponding string for the given key
		 */
		get(key, interpolationOptions) {
			return poly.t(key, interpolationOptions);
		}
	}

	return new StringResources();
});
